// extracted by mini-css-extract-plugin
export default {"headerContainer":"HeaderViewer-module__headerContainer--kkVCB","minimalHeader":"HeaderViewer-module__minimalHeader--O9qRU"};